export default __webpack_public_path__ + "static/media/plofile-edit-camera.73991edd.svg";